/**
 * Manages the behaviour of the designer's left-hand tool pane.
 */
namespace appn.designerv2 {
    export let toolPane: ToolPaneBase;
    
    export class ToolPaneBase {
        constructor() {
        }
        
        init(): void {
            this.bindEvents();
        }
        
        bindEvents() {
            canvas.bindDragIn();
        }
    }
}
